function decorateAuraLanes(){
  const colours={'almond-chocolate':'#e9d5e9','almond-roasted':'#e2ebc6','cashew-chocolate':'#f3ddb0','cashew-roasted':'#f0cec0','raisin-chocolate':'#ddd1ea','raisin-masala':'#eedbb4',trail:'#d9e8d1',makhana:'#d8e9e7',popped:'#f2d9b3'};
  document.querySelectorAll('[data-family-filter],[data-mix-filter]').forEach(button=>{
    if(button.querySelector('.aura-lane-art'))return;
    const family=button.dataset.familyFilter||button.dataset.mixFilter;
    button.style.setProperty('--lane-color',colours[family]||'#eadcc7');
    const scope=button.closest('[data-family-shop],[data-mix-builder]');
    const cards=scope?.querySelectorAll('[data-family],[data-mix-product]')||[];
    const card=Array.from(cards).find(card=>(card.dataset.family||card.dataset.mixFamily||card.dataset.familyFilter)===family);
    const source=card?.querySelector('img');
    if(source){const image=document.createElement('img');image.src=source.currentSrc||source.src;image.alt='';image.loading='lazy';image.className='aura-lane-art';button.prepend(image);}
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',decorateAuraLanes);else decorateAuraLanes();
document.addEventListener('shopify:section:load',decorateAuraLanes);
